import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import KNB from '@dp/knb';
import debugInfo from '../debug';
import sellChannelConfig from '../config/sellChannel';
import Cookie from '../utils/cookie';
var IS_DEBUG = debugInfo.IS_DEBUG,
    DEBUG_SELLCHANNEL = debugInfo.DEBUG_SELLCHANNEL;
var HOST = window.location.href;
var UA = (navigator.userAgent + '').toLowerCase();
var maoyanWXHostRegx = /\.maoyan\.com\/(myshow\/)?fe/;
var maoyanQQWHostRegx = /show\.(.*\.)?maoyan\.com\/qqw/;
var cookieFromString = '_source__from_';
var VER_REG_STR = '([0-9][0-9.a-zA-Z_]+)';

var regexp = function regexp(str) {
  return new RegExp(str, 'i');
};

var ua = {
  appName: '',
  appVersion: '',
  osName: '',
  osVersion: '',
  isNative: false
}; // 所有平台， 后面改成脚本自动赋值方式

var APP = {
  MEITUAN: 'meituan',
  DIANPING: 'dianping',
  MAOYAN: 'maoyan',
  GEWARA: 'gewara',
  DIANPING_M: 'dianping_m',
  DIANPING_CHWL: 'dianping_chwl',
  QQWALLET: 'qqwallet',
  MAOYAN_I: 'maoyan_i',
  MAOYAN_WECHAT: 'maoyan_wechat',
  WXAPP_WALLET: 'wxapp_wallet',
  WXAPP_SMARTVENUE: 'wxapp_smartvenue',
  WXAPP_ACTIVEAPP: 'wxapp_activeapp',
  WXAPP_FANS: 'wxapp_fans',
  TENGJING: 'tengjing',
  MAIDANBA: 'maidanba',
  CMBAPP: 'cmb_app',
  // 招商银行app
  ToutiaoMicroApp: 'toutiao_microapp',
  //
  DouyinMicroApp: 'douyin_microapp',
  //
  DouyinShowMicroApp: 'douyin_show_microapp' //

};

var osName = function () {
  if (/android/.test(UA)) return 'android';
  if (/ios|iphone|ipod|ipad/.test(UA)) return 'ios';
  if (/macintosh/.test(UA)) return 'mac';
  if (/windows/.test(UA)) return 'windows';
  return 'unknown';
}();

var osVersion = function () {
  var m;
  if (osName === 'android') m = UA.match(regexp('android ' + VER_REG_STR)) || UA.match(regexp('android/' + VER_REG_STR));
  if (osName === 'ios') m = UA.match(regexp(VER_REG_STR + ' like Mac OS X')) || UA.match(regexp('iOS/' + VER_REG_STR)); // mac / window 忽略版本

  return (m ? m[1] : '0').replace(/_/g, '.');
}();

var getByDebugInfo = function getByDebugInfo() {
  // 根据debug 判断
  var appName;

  for (var app in sellChannelConfig) {
    if (sellChannelConfig[app] === DEBUG_SELLCHANNEL) {
      appName = app;
      break;
    }
  }

  return {
    appName: appName,
    osVersion: osVersion,
    osName: osName,
    appVersion: '1.0.0'
  };
};

var getByHost = function getByHost() {
  // 根据域名 判断
  var appName = 'unknown'; // QQ-演出

  if (maoyanQQWHostRegx.test(HOST)) appName = APP.QQWALLET; // 猫眼微信H5

  if (maoyanWXHostRegx.test(HOST)) appName = APP.MAOYAN_WECHAT;
  return {
    appName: appName,
    osVersion: osVersion,
    osName: osName,
    appVersion: '1.0.0'
  };
};
/**
 * 根据 Cookie _source__from_ 判断容器环境
 *
 * @returns uaInfo
 */


var getByCookie = function getByCookie() {
  var appName = 'unknown';
  var from = Cookie.get(cookieFromString); // 腾竞 APP

  if (from.indexOf('tengjing_app') !== -1) appName = APP.TENGJING;
  return {
    appName: appName,
    osVersion: osVersion,
    osName: osName,
    appVersion: '1.0.0'
  };
}; // 优先KNB


ua = KNB.uaInfo() || {};
var _ua = ua,
    appName = _ua.appName;
if (/^imovie/.test(appName)) appName = APP.MAOYAN;
if (appName.indexOf('gewara') !== -1) appName = APP.GEWARA;

var checkIsNative = function checkIsNative(name) {
  return [APP.MAOYAN, APP.DIANPING, APP.MEITUAN, APP.GEWARA].indexOf(name) !== -1;
}; // 4大客户端内优先 Native 环境判断， 否则进行域名、cookie 等判断


if (!checkIsNative(appName)) {
  if (maoyanQQWHostRegx.test(HOST) || maoyanWXHostRegx.test(HOST)) {
    // 相关域名判断
    ua = getByHost();
  } else if (Cookie.get(cookieFromString)) {
    ua = getByCookie();
  } // 非Native环境, appName 需要 重新赋值


  appName = ua.appName;
} // 买单吧APP


if (UA.indexOf('maidanba') !== -1) appName = APP.MAIDANBA; // 招商银行 APP

if (UA.indexOf('mpbank') !== -1) appName = APP.CMBAPP;

if (UA.includes('toutiaomicroapp')) {
  appName = localStorage.getItem('_show_ua_appName') || '';
} // 小程序中打开的web-view


if (/_from=miniProgram_toutiao/.test(location.href)) {
  // 头条小程序
  appName = 'toutiao_microapp';
  localStorage.setItem('_show_ua_appName', appName);
} else if (/_from=miniProgram_douyin/.test(location.href)) {
  // 抖音小程序
  appName = 'douyin_microapp';
  localStorage.setItem('_show_ua_appName', appName);
} else if (/_from=douyin_show_microapp/.test(location.href)) {
  // 抖音小程序
  appName = 'douyin_show_microapp';
  localStorage.setItem('_show_ua_appName', appName);
}

if (~['wechat', 'qq'].indexOf(appName)) {
  var WX = require('@dp/knb/compiled/wx');

  WX.ready(function () {});

  if (/_from=miniProgram_movieshow/.test(location.href)) {
    // 钱包小程序
    appName = APP.WXAPP_WALLET;
  } else if (/_from=miniProgram_smartvenue/.test(location.href)) {
    // 智慧场馆小程序
    appName = APP.WXAPP_SMARTVENUE;
  } else if (/_from=miniProgram_activeapp/.test(location.href)) {
    // 主办自销
    appName = APP.WXAPP_ACTIVEAPP;
  } else if (/_from=miniProgram_smartvenue/.test(location.href)) {
    // 智慧场馆小程序
    appName = APP.WXAPP_SMARTVENUE;
  } else if (/_from=minip_fans/.test(location.href)) {
    // 粉丝小程序
    appName = APP.WXAPP_FANS;
  } else {
    // 微信环境默认是点评吃喝玩乐
    appName = APP.DIANPING_CHWL;
  }
} // 默认环境  点评 M 站


if (!appName || appName === 'unknown') appName = APP.DIANPING_M;

if (!Object.entries(APP).some(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return value === appName;
})) {
  // 如果找不到包名的情况下 判断下是否为猫眼APP
  if (/imovie\//.test(UA)) {
    appName = APP.MAOYAN;
  }
}

if (IS_DEBUG) {
  // debug 模式下  根据 app(sellChannel) 反查 app 信息
  ua = getByDebugInfo();
  appName = ua.appName;
}

Object.keys(APP).forEach(function (name) {
  ua["IS_".concat(name)] = APP[name] === appName;
});

for (var _i = 0, _arr = ['windows', 'mac', 'ios', 'android']; _i < _arr.length; _i++) {
  var os = _arr[_i];
  ua["is".concat(os.replace(/^\S/, function (s) {
    return s.toLocaleUpperCase();
  }))] = os === ua.osName;
}

ua.isNative = checkIsNative(appName);
ua.appName = appName;
export default ua;